import { routes } from "@/router/routes";
export default routes.filter(({ isMenu }) => isMenu);
